import * as React from 'react';
import * as _ from 'lodash';
import * as moment from 'moment';
import { Dispatch, connect } from 'react-redux';
import { IReportState, IApplicationState, AppActionCreators, ReportActionCreators, IHistogeneticsOrdersReportResponse } from '@nkr/store/index';
import { ColumnApi, CsvExportParams, FirstDataRenderedEvent, GridApi, GridReadyEvent, IHeaderParams, ProcessCellForExportParams, SortChangedEvent, ValueGetterParams } from 'ag-grid-community';
import { IHistogeneticsOrders } from '@nkr/models/index';
import { Button, FormControl } from 'react-bootstrap';
import SortableHeaderComponent from '@nkr/views/admin/center/list/common/sortable-header';
import { AgGridColumnProps, AgGridReact } from 'ag-grid-react';
import { GridWrapper, HeaderWrapper } from './styles';

import 'ag-grid-community/dist/styles/ag-theme-bootstrap.css';

interface IOwnProps {
    centerId: number,
    isCenterLogin: boolean
}

interface IStateProps {
    reports: IReportState
}

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getHistogeneticsOrdersReport: (startDate: string, endDate: string) => Promise<IHistogeneticsOrdersReportResponse>
}

type TProps = IStateProps & IDispatchProps & IOwnProps

interface IState {
    startDate: string,
    endDate: string,
    centerId: number,
    report: IHistogeneticsOrders[]
}

class VendorVerification extends React.Component<TProps, IState> {
    readonly state: IState = {
        startDate: '',
        endDate: '',
        centerId: 0,
        report: []
    }

    gridApi: GridApi = null;
    gridColumnApi: ColumnApi = null;

    onGridReady = (e: GridReadyEvent) => {
        this.gridApi = e.api;
        this.gridColumnApi = e.columnApi;

        this.gridApi.sizeColumnsToFit();
    }

    onFirstDataRendered = (e: FirstDataRenderedEvent) => {
        e.api.sizeColumnsToFit();
    }


    onSortChanged = (e: SortChangedEvent) => {
        e.api.refreshCells();
    }

    componentDidMount = () => {
        //get dates
        let startDate = '';
        let endDate = '';

        if (startDate == '' || endDate == '') {
            startDate = moment().startOf('month').subtract(3, 'months').format('YYYY-MM-DD');
            endDate = moment().startOf('month').add(1, 'months').format('YYYY-MM-DD');

        } else {
            startDate = this.state.startDate;
            endDate = this.state.endDate;
        }

        this.getData(startDate, endDate);
    }

    getData = (startDate: string, endDate: string) => {
        this.props.showLoading('Getting report data, one moment please...').then(() => {
            this.props.getHistogeneticsOrdersReport(startDate, endDate)
                .then((response: IHistogeneticsOrdersReportResponse) => {
                    this.setState({
                        startDate: startDate,
                        endDate: endDate,
                        report: response.data.results
                    });

                    this.props.hideLoading();
                }).catch((ex) => {
                    alert('An error occured while loading report data');
                    this.props.hideLoading();
                });
        });
    }



    handleDateChange = (e: React.FormEvent<FormControl & HTMLInputElement>) => {
        let name = e.currentTarget.name;
        let value = e.currentTarget.value;

        if (name == 'startDate') {
            this.setState({
                startDate: value
            });
        }

        if (name == 'endDate') {
            this.setState({
                endDate: value
            });
        }
    }

    handleDateRangeSearch = () => {
        this.getData(this.state.startDate, this.state.endDate);
    }

    handleExport = () => {
        let params: CsvExportParams = {
            columnGroups: true,
            fileName: 'histogenetics-orders.csv',
            processCellCallback: (params: ProcessCellForExportParams) => {
                let colDef = params.column.getColDef();

                if (colDef.headerName == 'Rank')
                    return params.node.rowIndex + 1;
                else if (colDef.colId == 'xpDate')
                    return moment(params.value).format('MM/DD/YYYY');

                return params.value;
            }
        };

        this.gridApi.exportDataAsCsv(params);
    }

    render = () => {
        const reportColumns: AgGridColumnProps[] = [
            {
                colId: 'Rank',
                field: 'rank',
                headerComponentFramework: (props: IHeaderParams) =>
                    <SortableHeaderComponent {...props}>
                        Rank
                    </SortableHeaderComponent>,
                headerName: 'Rank',
                width: 55,
                cellClass: 'center-list-cell',
                headerClass: 'center-list-header',
                resizable: true,
                suppressSizeToFit: true,
                valueGetter: (props: ValueGetterParams) => props.node.rowIndex + 1
            },
            {
                colId: 'entityType',
                field: 'entityType',
                headerName: 'Entity Type',
                cellClass: 'center-list-cell',
                headerClass: 'center-list-header',
                headerComponentFramework: (props: IHeaderParams) =>
                    <SortableHeaderComponent {...props}>
                        Entity Type
                    </SortableHeaderComponent>,
                width: 120,
                sortable: true,
                resizable: true
            },
            {
                colId: 'orderType',
                field: 'orderType',
                headerName: 'Order Type',
                cellClass: 'center-list-cell',
                headerClass: 'center-list-header',
                headerComponentFramework: (props: IHeaderParams) =>
                    <SortableHeaderComponent {...props}>
                        Order Type
                    </SortableHeaderComponent>,
                width: 140,
                sortable: true,
                resizable: true
            },
            {
                colId: 'status',
                field: 'status',
                headerName: 'Status',
                cellClass: 'center-list-cell',
                headerClass: 'center-list-header',
                headerComponentFramework: (props: IHeaderParams) =>
                    <SortableHeaderComponent {...props}>
                        Status
                    </SortableHeaderComponent>,
                width: 120,
                sortable: true,
                resizable: true
            },
            {
                colId: 'alias',
                field: 'alias',
                headerName: 'Alias',
                cellClass: 'center-list-cell',
                headerClass: 'center-list-header',
                width: 80,
                headerComponentFramework: (props: IHeaderParams) =>
                    <SortableHeaderComponent {...props}>
                        Alias
                    </SortableHeaderComponent>,
                sortable: true,
                resizable: true
            },
            {
                colId: 'firstName',
                field: 'firstName',
                headerName: 'First Name',
                cellClass: 'center-list-cell',
                headerClass: 'center-list-header',
                headerComponentFramework: (props: IHeaderParams) =>
                    <SortableHeaderComponent {...props}>
                        First Name
                    </SortableHeaderComponent>,
                width: 80,
                sortable: true,
                resizable: true
            },
            {
                colId: 'lastName',
                field: 'lastName',
                headerName: 'Last Name',
                cellClass: 'center-list-cell',
                headerClass: 'center-list-header',
                headerComponentFramework: (props: IHeaderParams) =>
                    <SortableHeaderComponent {...props}>
                        Last Name
                    </SortableHeaderComponent>,
                width: 80,
                sortable: true,
                resizable: true
            },
            {
                colId: 'orderDate',
                field: 'orderDate',
                headerName: 'Order Date',
                cellClass: 'center-list-cell',
                headerClass: 'center-list-header',
                headerComponentFramework: (props: IHeaderParams) =>
                    <SortableHeaderComponent {...props}>
                        Order Date
                    </SortableHeaderComponent>,
                width: 100,
                sortable: true,
                resizable: true
            },
            {
                colId: 'dateReceived',
                field: 'dateReceived',
                headerName: 'Date Received',
                cellClass: 'center-list-cell',
                headerClass: 'center-list-header',
                headerComponentFramework: (props: IHeaderParams) =>
                    <SortableHeaderComponent {...props}>
                        Date Received
                    </SortableHeaderComponent>,
                width: 100,
                sortable: true,
                resizable: true
            },
            {
                colId: 'resultsDate',
                field: 'resultsDate',
                headerName: 'Results Date',
                cellClass: 'center-list-cell',
                headerClass: 'center-list-header',
                headerComponentFramework: (props: IHeaderParams) =>
                    <SortableHeaderComponent {...props}>
                        Results Date
                    </SortableHeaderComponent>,
                width: 100,
                sortable: true,
                resizable: true
            } 
        ];

        return (
            <>
                <HeaderWrapper className='container-fluid'>
              
                        <div className='billing-header'>
                            Vendor Verification Report - ABO
                        </div>
                 

                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 20 }}>
                        <div style={{ display: 'flex' }}>
                            <div style={{ display: 'flex', alignItems: 'center', marginRight: 10 }}>
                                <div style={{ marginRight: 5 }}>Start Date:&nbsp;</div>
                                <div>
                                    <FormControl
                                        type='date'
                                        name='startDate'
                                        value={this.state.startDate}
                                        onChange={this.handleDateChange}
                                    />
                                </div>
                            </div>

                            <div style={{ display: 'flex', alignItems: 'center', marginRight: 10 }}>
                                <div style={{ marginRight: 5 }}>End Date:</div>
                                <div>
                                    <FormControl
                                        type='date'
                                        name='endDate'
                                        value={this.state.endDate}
                                        onChange={this.handleDateChange}
                                    />
                                </div>
                            </div>

                            <div>
                                <Button bsStyle='primary' onClick={this.handleDateRangeSearch}>Search</Button>
                            </div>
                        </div>

                        <div>
                            <Button bsStyle='primary' onClick={this.handleExport}>Export CSV</Button>
                        </div>
                    </div>
                </HeaderWrapper>

                <div className='row'>
                    <div className='col-sm-12'>
                        <GridWrapper id='grid-wrapper' className='container-fluid-max-sm ag-theme-bootstrap' style={{ marginBottom: 20 }}>
                            <AgGridReact
                                enableCellTextSelection={true}
                                enableRangeSelection={true}
                                columnDefs={reportColumns}
                                rowData={this.state.report}
                                // headerHeight={60}
                                noRowsOverlayComponentFramework={() =>
                                    <div>No data for the selected date range...</div>}
                                onGridReady={this.onGridReady}
                                // onGridSizeChanged={this.onGridSizeChanged}
                                onFirstDataRendered={this.onFirstDataRendered}
                                suppressCellSelection={true}
                                // rowBuffer={10000}
                                onSortChanged={this.onSortChanged}
                            />
                        </GridWrapper>

                    </div>
                </div>
            </>
        );
    }
}

const mapStateToProps = (appState: IApplicationState): IStateProps => {
    return {
        reports: appState.reports
    }
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        getHistogeneticsOrdersReport: (startDate, endDate) => {
            return dispatch(ReportActionCreators.getHistogeneticsOrdersReport(startDate, endDate));
        }
    }
}

export default connect<IStateProps, IDispatchProps, IOwnProps>(
    mapStateToProps,
    mapDispatchToProps)(VendorVerification);